import React from 'react';
import { StyledBannerContainer, StyledBannerLink, StyledBannerText } from './NotificationBanner.styles';

const NotificationBanner = () => {
    return (
        <StyledBannerContainer>
            <StyledBannerText>
                We&#x2019;ve migrated to a new platform. Using your existing login credentials, click <StyledBannerLink href="https://manzil.io">here</StyledBannerLink> to migrate now.
            </StyledBannerText>
        </StyledBannerContainer>
    );
};

export default NotificationBanner;
